import Icon from   '@material-ui/icons/AssignmentLate';
import List from './AbscList';
import Edit from './AbscEdit';
import Create from './AbscCreate';
//import Show from './SpeShow';


export default {
    list: List,
    edit: Edit,
    create: Create,
   // show: Show,
    icon: Icon,
};
